"use client";
import { jsx as s } from "react/jsx-runtime";
import * as t from "@radix-ui/react-progress";
import { forwardRef as e } from "react";
const i = e((o, r) => /* @__PURE__ */ s(t.Root, { "data-slot": "progress", ...o, ref: r }));
i.displayName = "ProgressRoot";
const a = e((o, r) => /* @__PURE__ */ s(t.Indicator, { "data-slot": "progress-indicator", ...o, ref: r }));
a.displayName = "ProgressIndicator";
export {
  a as ProgressIndicator,
  i as ProgressRoot
};
